const NotificationIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 2C10.3431 2 9 3.34315 9 5V5.2793C6.71883 6.13786 5.2 8.35526 5.2 11V16L3 18.2V19H21V18.2L18.8 16V11C18.8 8.35526 17.2812 6.13786 15 5.2793V5C15 3.34315 13.6569 2 12 2ZM12 22C13.1046 22 14 21.1046 14 20H10C10 21.1046 10.8954 22 12 22Z"
      fill="#808191"
    />
  </svg>
);

export default NotificationIcon;
